import { ReactNode } from 'react';

export function Card({ children }: { children: ReactNode }) {
  return (
    <div className="bg-primary-blue-B200/25 rounded-lg p-4 flex gap-2 justify-center items-center w-full md:w-[40%]">
      {children}
    </div>
  );
}
